var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 7.542969 L 24.289062 7.542969 L 24.289062 21.335938 L 13 21.335938 Z M 13 7.542969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.417969 12 L 24.289062 12 L 24.289062 16 L 5.417969 16 Z M 5.417969 12 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(29.40979%, 74.508667%, 94.898987%)",
    d: "M 13.976562 10.480469 L 20.070312 14.4375 L 13.976562 18.394531 C 13.292969 18.839844 13.097656 19.757812 13.539062 20.445312 C 13.980469 21.132812 14.894531 21.332031 15.582031 20.886719 L 23.59375 15.683594 C 24.015625 15.410156 24.269531 14.941406 24.269531 14.4375 C 24.269531 13.929688 24.015625 13.464844 23.59375 13.191406 L 15.582031 7.988281 C 14.894531 7.542969 13.980469 7.738281 13.539062 8.429688 C 13.097656 9.117188 13.292969 10.035156 13.976562 10.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(29.40979%, 74.508667%, 94.898987%)",
    d: "M 22.792969 12.953125 L 6.90625 12.953125 C 6.089844 12.953125 5.429688 13.617188 5.429688 14.4375 C 5.429688 15.257812 6.089844 15.921875 6.90625 15.921875 L 22.792969 15.921875 C 23.609375 15.921875 24.269531 15.257812 24.269531 14.4375 C 24.269531 13.617188 23.609375 12.953125 22.792969 12.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6c7c062f4038f1b0b961cfd10a531aad.svg";
export { ForwardRef as ReactComponent };